window.CHELBIT_PUBLIC_PATH = '/local/js/chelbit/freshhouse-app/dist/';
import { registerCore } from './app'
import './style.css';
import { registerComponents } from './components'

registerCore()
registerComponents()

window.initFreshhouseApp = function(options = {}) {
    const { el, data = {}, components, ...rest } = options
    const container = typeof el === 'string' ? document.querySelector(el) : el
    if (!container) {
        console.warn('FreshhouseApp: контейнер не найден')
        return null
    }
    return window.ChelbitVue.createApp({
        el: container,
        data,
        components,
        ...rest,
    })
}